angular.module('app')
    .directive('showReviews', function() {
        return {
            templateUrl: 'components/directives/show_reviews/view.show_reviews.html',
            controller: 'ShowReviewsController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                reviews: '=reviews'
            }
        };
    });
